import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// import '../components/TajaKhabarCard.css'

const baseUrl = "https://api.shabdtoday.com/";
const baseUrllocal = "https://localhost:44351/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const isDesktopScreen = () => window.innerWidth >= 1024;

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "..."); // append dots
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};


const local = "https://localhost:44351/api/home/tajaKhabars"
const online = "https://api.shabdtoday.com/api/home/tajaKhabars"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
const isMobile = window.innerWidth <= 768;



const TajaKhabarCard = ({ disableHelmet }) => {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);

      if (response.data && response.data.tazaKhabars.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response.data.tazaKhabars.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    const handleResize = () => setIsDesktop(isDesktopScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);


  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      // console.log("Sending request to:", clicklocal);
      // console.log("Payload:", { mainKhabarId });

      const response = await axios.post(clickonline, { mainKhabarId: mainKhabarId });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count:", response.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("Server error:", error.response.status, error.response.data);
      } else if (error.request) {
        console.error("No response from server:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const generateShareLinks = (mainKhabarId, newsHeading) => {
    const encodedNewsHeading = encodeURIComponent(newsHeading);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {!disableHelmet && (
        <Helmet>
          <title>ताज़ा खबरें हिंदी में – आज की बड़ी ब्रेकिंग न्यूज़ | ShabdToday</title>

          <meta name="title" content="ताज़ा खबरें हिंदी में – आज की बड़ी ब्रेकिंग न्यूज़ | ShabdToday" />
          <meta name="description" content="आज की ताज़ा खबरें हिंदी में पढ़ें। राजनीति, खेल, मनोरंजन, तकनीकी और देश-दुनिया की हर बड़ी ब्रेकिंग न्यूज़ सबसे पहले, सबसे तेज़ और सटीक।" />
          <meta name="keywords" content="ताज़ा खबरें, आज की ताज़ा खबरें, ताज़ा समाचार, ब्रेकिंग न्यूज़ हिंदी, देश दुनिया की खबरें, हिंदी न्यूज़, मुख्य खबरें" />
          <meta name="robots" content="index, follow" />
          <meta name="author" content="ShabdToday Team" />

          {/* Canonical URL */}
          <link rel="canonical" href="https://shabdtoday.com/TajaKhabar-News" />

          {/* Open Graph Basic */}
          <meta property="og:title" content="ताज़ा खबरें हिंदी में – ब्रेकिंग न्यूज़ | ShabdToday" />
          <meta property="og:description" content="राजनीति, खेल, मनोरंजन और तकनीकी की ताज़ा खबरें — देश-दुनिया की बड़ी ब्रेकिंग न्यूज़ हिंदी में पढ़ें।" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://shabdtoday.com/TajaKhabar-News" />
          <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

          {/* Schema Markup (Google Rich Results) */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              "name": "ताज़ा खबरें हिंदी – ShabdToday",
              "url": "https://shabdtoday.com/TajaKhabar-News",
              "description": "ShabdToday पर पढ़ें ताज़ा खबरें, आज की बड़ी ब्रेकिंग न्यूज़ और देश-दुनिया की मुख्य खबरें हिंदी में।",
              "publisher": {
                "@type": "Organization",
                "name": "ShabdToday",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://shabdtoday.com/design/images/logo-s.webp"
                }
              }
            })}
          </script>
          <h1 className="head hidden-start">
            हिंदी समाचार आज की ताज़ा खबरें
          </h1>

          <h2 style={{ marginLeft: 10, marginTop: 8 }}>
            आज की देश दुनिया की ताज़ा खबरें हिंदी में
          </h2>

          <h3 style={{ marginLeft: 10, marginTop: 8 }}>
            आज के ताज़ा राजनीति | खेल | मनोरंजन | तकनीकी हिंदी समाचार अपडेट
          </h3>
        </Helmet>
      )}
      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
                      const htmlContent = isDesktop
                        ? truncateHtml(post.newsTag, 100)
                        : post.newsTag;
                      return (
                        <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">
                              <div className="ak-module-badges" />
                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                  aria-label="Shabd Today"
                                  title={stripHtmlTags(post.newsTag)}
                                >
                                  <div className="ak-module-details mb-2">
                                    <h1 className="ak-module-title">
                                      <Link
                                        to={`/News-Details/${post.slug}`}
                                        onClick={(e) => {
                                          e.preventDefault(); // Prevent default navigation
                                          handleNewsClick2(post.slug, post.mainKhabarId);
                                        }}
                                        rel="bookmark"
                                        aria-label="Shabd Today"
                                        title={stripHtmlTags(post.newsTag)}
                                      >
                                        <span
                                          className="responsive-font"
                                          style={{ lineHeight: "30px" }}
                                          dangerouslySetInnerHTML={{ __html: htmlContent }}
                                        />
                                      </Link>
                                    </h1>
                                    {/* <span className="tm-stmp">
                                      <FontAwesomeIcon icon={faClock} style={{ color: "crimson", fontSize: "12px" }} />
                                      &nbsp;{getTimeAgoInHindi(post.date)}
                                      </span> */}
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                    <img
                                      src={baseUrl + post.newsImage}
                                      alt={stripHtmlTags(post.newsTag, 150)}
                                      width={410}
                                      height={300}
                                      style={{ objectFit: "fill" }}
                                    />
                                  </div>

                                  {/* <div className="ak-featured-thumb  size-500" style={{ marginBottom: "10px" }}>
                                    <img
                                      fetchpriority="high"
                                      decoding="async"
                                      width={410}
                                      height={300}
                                      // loading="lazy"
                                      style={{ objectFit: "fill" }}
                                      src={baseUrl + post.newsImage}
                                      className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
                                      alt={stripHtmlTags(post.newsHeading, 150)}
                                      data-src={baseUrl + post.newsImage}
                                      data-sizes="auto"
                                      data-srcset={baseUrl + post.newsImage}
                                      data-expand={700}
                                    />
                                  </div> */}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );
};
export default TajaKhabarCard